import { useQuery } from '@tanstack/react-query';
import { fetchCustomerData } from '@Services/init/partnerWelcome.api.ts';

export const useFetchCustomerData = () =>
  useQuery({
    queryFn: fetchCustomerData,
    queryKey: ['partnerData'],
    enabled: false,
  });
